import type { LlmCredentialSummary } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeleteLlmCredentialDialogProps {
  credential: LlmCredentialSummary | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteLlmCredentialDialog({
  credential,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteLlmCredentialDialogProps) {
  return (
    <Modal open={credential !== null} title="Remove LLM credential" onClose={onCancel}>
      <p>
        Remove <strong>{credential?.label}</strong>? Workbench sessions using this key will fail once
        it's gone. This can't be undone.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Removing…" : "Remove"}
        </Button>
      </div>
    </Modal>
  );
}
